/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

import * as actions from './actions';
import * as oPath from '../../../Lib/Object/Path/Immutable';

const defaultState = {};

const importedWorksheetsReducer = (state = defaultState, { type, id, params, selectedTest }) => {
  switch (type) {
    case actions.IMPORT_WORKSHEET_UPDATE_SEARCH:
      return oPath.setMultiple(state, id, { searching: true, ...params });

    case actions.IMPORT_WORKSHEET_UPDATE_SEARCH_RESOLVE:
      return oPath.setMultiple(state, id, { selectedTest, searching: false });

    case actions.IMPORT_WORKSHEET_UPDATE_SEARCH_REJECT:
      return oPath.set(state, `${id}.searching`, false);

    case actions.IMPORT_WORKSHEET_INIT:
      return oPath.set(state, id, {
        searching: false,
        selectedTest: null,
        importFromThisSample: true,
        importFromSpecificSample: false,
        importFromSpecificTest: false,
        testMethodIds: params.testMethodIds,
        thisSampleId: params.thisSampleId,
      });

    case actions.IMPORT_WORKSHEET_INIT_RESOLVE:
      return oPath.setMultiple(state, id, {
        importFromThisSample: selectedTest ? selectedTest.Header.Sample.Id === state[id]?.thisSampleId : true,
        importFromSpecificSample: selectedTest ? selectedTest.Header.Sample.Id !== state[id]?.thisSampleId : false,
        selectedSample: selectedTest ? selectedTest.Header.Sample : null,
        selectedTest,
        searching: false,
      });

    case actions.IMPORT_WORKSHEET_CLEANUP:
      return oPath.del(state, id);

    default:
      return state;
  }
};

export default importedWorksheetsReducer;
